export default "a4a6ccea12dde81e.svg"